import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-new-user',
  templateUrl: './users-new-user.component.html',
  styleUrls: ['./users-new-user.component.scss']
})
export class UsersNewUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
